import React from 'react';

import { AutomatedInsightsProvider } from './context';
import AutomatedInsightsComponent from './AutomatedInsights';
import connect from '../../utils/connect';

const AutomatedInsights = ({
    user,
    client,
    filters,
}: {
    user: any;
    client: any;
    filters: any;
}) => {
    return (
        <AutomatedInsightsProvider
            user={user}
            client={client}
            filters={filters}
        >
            <AutomatedInsightsComponent />
        </AutomatedInsightsProvider>
    );
};

export default connect(['user', 'client', 'filters'])(AutomatedInsights);
